var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.hideNavigation)?_c('app-header'):_vm._e(),_c('div',{staticClass:"app-main"},[_c('div',{staticClass:"app-content",class:{
        'app-content--fullwidth': _vm.$route.meta.noContainer || _vm.$route.meta.hideNavigation
      }},[_c('router-view',{key:_vm.$route.path})],1)]),(!_vm.$route.meta.hideNavigation)?_c('app-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }